import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
import Image from 'next/image';
import { getImageBasePath } from 'utils/generics';
import * as Styles from '../styles';

interface IProps {
    onClick: () => void;
}

const PendingV1: React.FC<IProps> = (props) => {
    const { onClick } = props;
    return (
        <Styles.Wrapper>
            <Styles.Banner>
                <Image
                    width={'250px'}
                    height={'250px'}
                    alt={''}
                    src={getImageBasePath('/images/payment_pending.svg')}
                />
            </Styles.Banner>
            <Styles.LightSubTextBlock>
                <Styles.Text>Payment Pending</Styles.Text>
                Your payment is currently being processed. Please check the
                transactions tab in 5 minutes for the final status.
            </Styles.LightSubTextBlock>
            <Styles.GoHomeButtonWrapper>
                <PrimaryButton onClick={onClick}>Go to Home</PrimaryButton>
            </Styles.GoHomeButtonWrapper>
        </Styles.Wrapper>
    );
};

export default PendingV1;
